import { combineReducers } from "redux";
import settingReducer from "./settingsSlice";
import profileReducer from "./profileSlice";
import authSlice from "./authSlice";

const rootReducer = combineReducers({
  profile: profileReducer,
  setting: settingReducer,
  authProvider: authSlice,
});

export default rootReducer;
